import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Client-side navigation keeps the window's scroll position; a page opened
 * from the bottom of a long list (or right after impersonating a customer)
 * would otherwise start halfway down. Reset to the top on every path change.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname]);
  return null;
}
